"use client";
import { Box, Modal, IconButton, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useState } from "react";
import RegisterForm from "@/components/core/register-form";
import { Trans } from "@lingui/react/macro";
import OtpForm from "@/components/core/otp-form";

const RegisterModal: React.FC<{
  open: boolean;
  handleClose: () => void;
  lang: string;
}> = ({ open, handleClose, lang }) => {
  const [openVerifyEmail, setOpenVerifyEmail] = useState(false);
  const handleRegisterSuccess = () => {
    setOpenVerifyEmail(true);
  };
  const handleChange = () => {
    setOpenVerifyEmail(false);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          width: { xs: "90%", md: "unset" },
          bgcolor: "background.paper",
          borderRadius: "8px",
          boxShadow: 3,
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          p: 4,
          maxWidth: "450px",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: "8px",
            right: "8px",
            color: "gray",
          }}
        >
          <CloseIcon />
        </IconButton>
        <Box sx={{ width: "100%" }}>
          {!openVerifyEmail && (
            <>
              <p className="mb-[15px] text-[22px] font-extrabold tracking-[-0.3px] md:text-[25px]">
                <Trans>Register as private customer</Trans>
              </p>
              <p className="mb-[40px]">
                <Trans>
                  Welcome to our private client registration! Register for exclusive services with
                  secure, confidential information.
                </Trans>
              </p>
              <RegisterForm
                lang={lang}
                activeTab={"private"}
                onRegisterSuccess={handleRegisterSuccess}
              />
            </>
          )}
          {openVerifyEmail && <OtpForm handleChange={handleChange} lang={lang} />}

          <Button
            sx={{ mt: "-40px" }}
            data-testid="cancel-btn"
            variant="outlined"
            color="primary"
            fullWidth
            onClick={handleClose}
          >
            <Trans>Cancel</Trans>
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default RegisterModal;
